import uniqueId from 'lodash/uniqueId';

import { usePalletsTypes } from 'constants/palletTypes';
import { PALLETS_ITEM_PREFIX } from 'constants/uniqueIdPrefixes';
import { PalletsItem } from 'interfaces';

import { ExcelPalletsItem } from '../types';

export const excelPalletsItemToPalletsItemMapper = (
   palletTypesData: ReturnType<typeof usePalletsTypes>['palletTypesData'],
) => {
   return (excelPalletsItem: ExcelPalletsItem): PalletsItem => {
      const pallet = palletTypesData.find(item => item.name === excelPalletsItem.palletType);

      const label = pallet ? `${pallet.label} ${pallet.dimensions}` : excelPalletsItem.palletType;

      return {
         uuid: uniqueId(PALLETS_ITEM_PREFIX),
         palletsAmount: excelPalletsItem.palletsAmount,
         palletType: {
            value: excelPalletsItem.palletType,
            label,
         },
      };
   };
};
